<template>
  <div id="all-pokemon">
    <!-- {{detailed}} -->
    <!-- <pre>{{ListPage.filters.currentPage}}</pre> -->
    <div
      class="list has-text-left"
      v-if="filtered"
    >

      <div class="columns">
        <div class="column is-7 is-unselectable">
          <!-- <div class="pokemon-type-large pokemon-type-grass" :class="{'inactive': ListPage.filters.type !== ''}" @click="ListPage.filters.type = ''">ALL</div><br> -->
          <div
            class="pokemon-type"
            :class="['pokemon-type-' + t, {'inactive': ListPage.filters.type !== t}]"
            @click="setTypeFilter(t)"
            v-for="(t, i) in PokemonTypes"
            :key="i"
          >{{t}}</div>
          <!-- <b-field label="Type">
            <b-select placeholder="Select type" v-model="ListPage.filters.type" @input="updateFilter('type', $event)">
              <option value="">Any</option>
              <option v-for="(t, i) in PokemonTypes" :value="t" :key="i">
                {{t.toTitle()}}
              </option>
            </b-select>
          </b-field> -->
        </div>
        <div class="column">
          <!-- <p>Pokemon per page:</p> -->
          <b-field>
            <p
              class="control"
              v-for="i in maxItemsOptions"
              :key="i"
            >
              <button
                :class="{'is-primary': ListPage.filters.maxItems === i}"
                @click="setItemsPerPage(i)"
                class="button"
              >{{i}}</button>
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <div class="field">
            <b-switch
              v-model="ListPage.filters.largeImages"
              type="is-info"
              @input="updateFilter('largeImages', $event)"
            >Large images</b-switch>
          </div>
        </div>
      </div>

      <br>

      <div class="columns heading">
        <div class="column">Image</div>
        <div class="column">Name</div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'statsTotal'}"
          @click="setSortBy('statsTotal')"
        >
          Total
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'hp'}"
          @click="setSortBy('hp')"
        >
          {{statNames['hp']}}
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'attack'}"
          @click="setSortBy('attack')"
        >
          {{statNames['attack']}}
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'defense'}"
          @click="setSortBy('defense')"
        >
          {{statNames['defense']}}
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'special-attack'}"
          @click="setSortBy('special-attack')"
        >
          {{statNames['special-attack']}}
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'special-defense'}"
          @click="setSortBy('special-defense')"
        >
          {{statNames['special-defense']}}
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div
          class="column is-1 sortable"
          :class="{'is-selected': ListPage.filters.sortBy === 'speed'}"
          @click="setSortBy('speed')"
        >
          {{statNames['speed']}}
          <span class="icon"><i class="mdi mdi-sort-descending"></i></span>
        </div>
        <div class="column is-2">Type</div>
      </div>

      <div
        class="pokemon columns is-bordered"
        v-for="r in $range(pageStart, pageStart + ListPage.filters.maxItems)"
        :key="r"
        v-if="filtered[r]"
        @click="goPokemon(filtered[r].identifier)"
      >
        <div class="column">
          <img
            :src="$pkImg(imageSize, filtered[r].identifier, filtered[r].species_id)"
            alt=""
            @error="$imgErr($event, 'sprite')"
          >
        </div>
        <div class="column">
          <span class="species-name">{{filtered[r].name}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].statsTotal}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].stats['hp']}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].stats['attack']}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].stats['defense']}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].stats['special-attack']}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].stats['special-defense']}}</span>
        </div>
        <div class="column is-1">
          <span>{{filtered[r].stats['speed']}}</span>
        </div>
        <div class="column is-2">
          <pokemon-type
            :id="id"
            v-for="id in $priorityType($commaStringToArray(filtered[r].type_id), local.filters.typeID)"
            :key="id"
          ></pokemon-type>
        </div>
      </div>
    </div>
    <br>
    <nav
      class="pagination is-centered"
      role="navigation"
      aria-label="pagination"
    >
      <paginate
        v-model="local.filters.currentPage"
        :page-count="pageCount"
        :page-range="3"
        :margin-pages="2"
        :clickHandler="enterPage"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :container-class="'pagination-list'"
        :page-link-class="'pagination-link'"
        :prev-link-class="'pagination-previous has-text-warning'"
        :next-link-class="'pagination-next has-text-warning'"
        :no-li-surround="true"
        :active-class="'is-current'"
        ref="paginate"
      >
      </paginate>
    </nav>
  </div>
</template>

<script>
import config from '../../../config'
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import PokemonType from '../../PokemonType'

export default {
  components: {
    Paginate,
    PokemonType,
  },
  data() {
    return {
      // detailed: [],
      local: {
        filters: {
          currentPage: 2,
          type: '',
          typeID: '',
          sortBy: '',
          maxItems: 10,
        },
      },
      maxItemsOptions: [5, 10, 25, 50],
      paths: config.paths,
      statNames: config.data.pokemon.stats,
    }
  },
  computed: {
    filtered() {
      let f = this.PokemonListStats.slice()
      // set current page
      if (this.ListPage.filters.currentPage > 1) {
        this.local.filters.currentPage = this.ListPage.filters.currentPage
      }
      // type filter
      if (this.ListPage.filters.type !== '') {
        if (this.ListPage.filters.type !== this.local.filters.type) {
          this.local.filters.type = this.ListPage.filters.type
          this.resetCurrentPage()
        }
        let pk = Object.keys(this.PokemonTypes)
        let typeID = -1
        for (let i = 0; i < pk.length; i++) {
          if (this.PokemonTypes[pk[i]] === this.ListPage.filters.type) {
            typeID = String(pk[i])
            break
          }
        }
        this.local.filters.typeID = typeID
        f = f.filter(x => this.$commaStringToArray(x.type_id).indexOf(typeID) !== -1)
      }
      // sort
      if (this.ListPage.filters.sortBy !== '') {
        if (this.ListPage.filters.sortBy !== this.local.filters.sortBy) {
          this.local.filters.sortBy = this.ListPage.filters.sortBy
          this.resetCurrentPage()
        }
        if (this.ListPage.filters.sortBy === 'statsTotal') {
          f.sort((a, b) => {
            return a[this.ListPage.filters.sortBy] < b[this.ListPage.filters.sortBy] ? -1 : a[this.ListPage.filters.sortBy] > b[this.ListPage.filters.sortBy] ? 1 : 0
          }).reverse()
        } else {
          // stats
          f.sort((a, b) => {
            return a.stats[this.ListPage.filters.sortBy] < b.stats[this.ListPage.filters.sortBy]
              ? -1
              : a.stats[this.ListPage.filters.sortBy] > b.stats[this.ListPage.filters.sortBy]
              ? 1
              : 0
          }).reverse()
        }
      }

      return f
    },
    imageSize() {
      return this.ListPage.filters.largeImages ? 'sprite' : 'sprite-small'
    },
    pageStart() {
      return (this.ListPage.filters.currentPage - 1) * this.ListPage.filters.maxItems
    },
    pageCount() {
      return Math.ceil(this.filtered.length / this.ListPage.filters.maxItems)
    },
    ...mapGetters({
      PokemonListStats: 'pokemon/listStats',
      PokemonList: 'pokemon/list',
      PokemonTypes: 'pokemon/types',
      ListPage: 'pokemon/listPage',
    }),
  },
  mounted() {
    // this._addStatsToPokemon()
    if (!this.$store.state.pokemon.listStats) {
      axios
        .get('/data/pokemon.simple-stats.json')
        .then(response => {
          if (response.data) {
            this['pokemon/setSimpleStatsList'](response.data)
          }
        })
        .catch(error => {
          console.log('error')
          console.log(error)
        })
    }
  },
  methods: {
    goPokemon(identifier) {
      this.$router.push('/pokemon/' + identifier)
    },
    // used to make the "pokemon.simple-stats.json"
    _getBasicPokeData(pokemon) {
      let data = []
      data = [
        {
          id: pokemon.id,
          name: pokemon.form_pokemon_name || pokemon.species_name,
          identifier: pokemon.identifier,
          species_identifier: pokemon.species_identifier,
          species_id: pokemon.species_id,
          type_id: pokemon.type_id,
        },
      ]
      if (typeof pokemon.forms !== 'undefined' && pokemon.forms.length > 0) {
        // check forms
        for (let j = 0; j < pokemon.forms.length; j++) {
          data.push(...this._getBasicPokeData(pokemon.forms[j]))
        }
      }
      return data
    },
    _addStatsToPokemon() {
      let raw = []
      Object.assign(raw, this.PokemonList)

      for (let i = 0; i < raw.length; i++) {
        let data = this._getBasicPokeData(raw[i])
        this.detailed.push(...data)
      }
      for (let i = 0; i < this.detailed.length; i++) {
        axios
          .get('/data/json/' + this.detailed[i].identifier + '.json')
          .then(response => {
            if (response.data) {
              // add stats
              console.log('json')
              let simpleStats = {}
              for (let j = 0; j < response.data.stats.length; j++) {
                simpleStats[response.data.stats[j].identifier] = response.data.stats[j].base_stat
              }
              let d = this.detailed[i]
              d.stats = simpleStats
              d.statsTotal = this.statsTotal(d.stats)
              this.$set(this.detailed, i, d)
            }
          })
          .catch(error => {
            console.log('json error')
            console.log(error)
          })
      }
    },
    resetCurrentPage() {
      // reset current page
      this.local.filters.currentPage = 1
      this.updateFilter('currentPage', 1)
    },
    enterPage(page) {
      this.updateFilter('currentPage', page)
    },
    statsTotal(stats) {
      let sum = 0
      let sk = Object.keys(stats)
      for (let i = 0; i < sk.length; i++) {
        sum += parseInt(stats[sk[i]])
      }
      return sum
    },
    setItemsPerPage(set) {
      if (this.maxItemsOptions.indexOf(set) === -1) {
        return false
      }
      this.updateFilter('maxItems', set)
      this.local.filters.maxItems = set
      this.resetCurrentPage()
    },
    setTypeFilter(v) {
      if (this.local.filters.type === v) {
        // deselect type
        v = ''
        this.local.filters.type = v
      }
      this.updateFilter('type', v)
    },
    setSortBy(v) {
      if (this.ListPage.filters.sortBy === v) {
        this['pokemon/listPageSetFilter']({ key: 'sortBy', value: '' })
      } else {
        this['pokemon/listPageSetFilter']({ key: 'sortBy', value: v })
      }
    },
    updateFilter(key, event) {
      this['pokemon/listPageSetFilter']({ key, value: event })
    },
    ...mapActions(['pokemon/setSimpleStatsList', 'pokemon/listPageSetFilter']),
  },
}
</script>


<style lang="scss">
@import '~@/assets/css/variables.scss';

#all-pokemon {
  .pokemon {
    &:hover {
      background-color: $black;
      cursor: pointer;
    }
  }
  .columns {
    &.is-bordered {
      border: 1px solid $grey;
      border-top: none;
    }
    &.heading {
      border-bottom: 1px solid $grey;
      font-weight: 700;
      font-size: 14px;
      .sortable {
        cursor: pointer;
        &:hover {
          color: $black-bis;
        }
        &.is-selected {
          color: $primary;
          font-weight: 700;
          // i {
          // color: $warning;
          // }
        }
      }
    }
    .column {
      align-self: center;
    }
  }
}
</style>
